export default __webpack_public_path__ + "static/media/COHS.7550cea8.pdf";